export default "__VITE_ASSET__BRx9zkuk__"